import StudentRow from "./StudentRow";

export default StudentRow;
